/* eslint no-console: "off",  */
import React from 'react';
import PropTypes from 'prop-types';
//
import Button from '@cx/ui/Button';
import TextInput from '@cx/ui/TextInput';
import Alert from '@cx/ui/Alert';
import Panel from 'react-bootstrap/lib/Panel';

import './dealershipList.page.scss';

export default class DealershipListPage extends React.Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    location: PropTypes.object,
    match: PropTypes.object
  };

  constructor(props) {
    super(props);
    const self = this;
    self.state = {
      entityId: '',
      alertVisible: !!this.props.match.params.alert,
      environment: window.genesisSettings.environment
    };
  }

  onListItemClick = event => {
    const entityId = event.target.value;
    this.history.push(`/vehicles/${entityId}`);
  };

  onSearchInputChange = event => {
    const entityId = event.target.value;
    this.setState({ entityId });
  };

  onSearchButtonClick = event => {
    const entityId = this.state.entityId;
    if (!entityId) {
      // Just do nothing - should be pretty clear that an entityId is required for the button to work.
      return;
    }

    this.history.push(`/vehicles/${entityId}`);
  };

  get hardcodedEntityIds() {
    // The environment refers to the CDOM environment - not the application environment
    if (this.state.environment && this.state.environment === 'NON_PRODUCTION') {
      return [
        {
          entityId: 'RlVTSU9OOkRFQUxFUjoxMTY5ODI0',
          name: 'Dealer ABC Automotive'
        },
        {
          entityId: 'RlVTSU9OOkRFQUxFUjo0MDAwMTcyMzg',
          name: 'NEW VIM P IC TYPE 2 STORE 1'
        },
        {
          entityId: 'RlVTSU9OOkRFQUxFUjo0MDAwMTcyNTM',
          name: 'NEW VIM Q IC TYPE 2, STORE 1'
        }
      ];
    }

    // TODO: find more prod entityId
    if (this.state.environment && this.state.environment === 'PRODUCTION') {
      return [
        {
          entityId: 'RlVTSU9OOkRFQUxFUjoxMTY5ODI0',
          name: 'Dealer ABC Automotive'
        }
      ];
    }

    return [];
  }

  get message() {
    if (this.props.location && this.props.location.state) {
      return this.props.location.state.messageText;
    }
    return '';
  }

  get history() {
    return this.props.history;
  }

  render() {
    const self = this;

    if (this.props.match.params.alert && !this.state.alertVisible) {
      this.setState({ alertVisible: true });
    }

    return (
      <div className="dealership-list">
        <header className="vince-page-header">
          {self.message && (
            <Alert htmlId="infoAlert" type="info">
              {self.message}
            </Alert>
          )}

          <h1>Dealership List for the {self.state.environment} environment</h1>
        </header>
        <Panel>
          {!self.hardcodedEntityIds.length && <p>Sorry, there are no sample entities defined for the {self.state.environment} environment. Input an Entity Id below to view its inventory.</p>}

          <form>
            <div className="form-btn-group">
              <TextInput addOnPosition="append" htmlId="textInputAppendChild" label="Please input the Entity ID" name="textInputAppendChild" onChange={self.onSearchInputChange} value={self.state.entityId}>
                <TextInput.Addon addonType="button" buttonStyle="primary" htmlId="textInputAppendButton" onClick={self.onSearchButtonClick}>
                  Open VLP
                </TextInput.Addon>
              </TextInput>
            </div>
          </form>

          <ul>
            {self.hardcodedEntityIds.map((value, index) => (
              <li key={'entityId-' + value.entityId}>
                <Button htmlId={`btn-${value}`} value={value.entityId} buttonStyle="link" onClick={self.onListItemClick}>
                  {`Open VLP for list of sample vehicles associated with ${value.name}`}
                </Button>
              </li>
            ))}
          </ul>
        </Panel>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dealership/dealershipList.page.js